import React from 'react';
import { Ui }from '@einstein/schedule-platform';

import { ButtonWrapper, Container, Content, Subtitle, Title } from './styles';

interface UnitCardProps {
  imgSrc?: string;
  title: string;
  subtitle: string[];
  onClickSeeDetails: () => void;
}

export const UnitCard: React.FC<UnitCardProps> = ({
  subtitle,
  title,
  imgSrc,
  onClickSeeDetails
}) => {
  return (
    <Container>
      <img src={imgSrc} alt={title} />
      <Content>
        <Title>{title}</Title>
        <Subtitle>
          <span>{subtitle.length > 0 && subtitle[0]}</span>
          {subtitle.length > 1 &&
            subtitle.slice(1, subtitle.length).map((text, index) => (
              <span key={index}>
                <br />
                {text}
              </span>
            ))}
        </Subtitle>
        <ButtonWrapper>
          <Ui.Button className='details-btn' title="Ver Detalhes" onClick={() => onClickSeeDetails()} />
        </ButtonWrapper>
      </Content>
    </Container>
  );
};
